import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { InvoiceKsefStatus } from '../enums';
import { InvoiceKsefStatusProviderService } from '../providers';

@Pipe({
  name: 'invoiceKsefStatus',
})
export class InvoiceKsefStatusPipe implements PipeTransform {
  private readonly provider = inject(InvoiceKsefStatusProviderService);

  public transform(status: InvoiceKsefStatus): Observable<string> {
    return this.provider.labelFor(status);
  }
}
